import React from "react";
import ContainerList from "./ContainerList";
const AgentStreamDemo: React.FC = () => {
  return (
    <div className="container mx-auto p-4">
      <ContainerList />
    </div>
  );
};

export default AgentStreamDemo;
